// extracted by mini-css-extract-plugin
module.exports = {"tabList":"Tabs_tabList__1Oa95","tab":"Tabs_tab__3GNTS","selectedTab":"Tabs_selectedTab__3rGPk"};